/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trialDays: NonNullable<unknown> }} Common_Try_Free_For_DaysInputs */

const en_common_try_free_for_days = /** @type {(inputs: Common_Try_Free_For_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Try the app free for ${i?.trialDays} days`)
};

const es_common_try_free_for_days = /** @type {(inputs: Common_Try_Free_For_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prueba la app gratis por ${i?.trialDays} días`)
};

/**
* | output |
* | --- |
* | "Try the app free for {trialDays} days" |
*
* @param {Common_Try_Free_For_DaysInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_try_free_for_days = /** @type {((inputs: Common_Try_Free_For_DaysInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Try_Free_For_DaysInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_try_free_for_days(inputs)
	return en_common_try_free_for_days(inputs)
});